import type { OwnerListQuery, Page } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import { SearchX } from 'lucide-react';
import { EmptyState } from '../../components/EmptyState';
import { ListSearch } from '../../components/ListSearch';
import type { ListQueryControls } from '../../lib/use-list-query';
import type { OwnerListItem } from './owners.api';

interface OwnersTableProps {
  page: Page<OwnerListItem>;
  columns: TableColumnsType<OwnerListItem>;
  list: ListQueryControls<OwnerListQuery>;
  isRefreshing: boolean;
}

/** Search box plus the server-paged table; the old rows stay up, dimmed, while the next page loads. */
export function OwnersTable({ page, columns, list, isRefreshing }: OwnersTableProps) {
  return (
    <div className="flex flex-col gap-4">
      <ListSearch value={list.query.q} placeholder="Search name" onSearch={(q) => list.setQuery({ q }, { replace: true })} />
      <Table
        rowKey="id"
        dataSource={page.items}
        columns={columns}
        loading={isRefreshing}
        scroll={{ x: 'max-content' }}
        locale={list.isFiltered ? { emptyText: <NoMatchingOwners /> } : undefined}
        {...list.tableProps<OwnerListItem>(page.total)}
      />
    </div>
  );
}

function NoMatchingOwners() {
  return <EmptyState icon={SearchX} title="No matching owners" description="No owners match this search." />;
}
